import { render, staticRenderFns } from "./MotorLogbookFields.vue?vue&type=template&id=19a86648&scoped=true"
import script from "./MotorLogbookFields.vue?vue&type=script&lang=js"
export * from "./MotorLogbookFields.vue?vue&type=script&lang=js"
import style0 from "./MotorLogbookFields.vue?vue&type=style&index=0&id=19a86648&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19a86648",
  null
  
)

export default component.exports